<template>
  <div class="selector-wrapper">
    <Flex class="selector" v-if="options.length">
      <Flex class="dropdown-toggle" @click="toggleMenu()">
        <span class="dropdown-selected">{{ getCategoryName(selectedOption) }}</span>
        <Icon :src="'navigate-down'"></Icon>
      </Flex>
      <Flex class="menu" v-show="showMenu && options.length">
        <Flex
          class="menu-item"
          @click="updateOption(option)"
          v-for="(option, idx) in options"
          :key="idx"
        >
          {{ getCategoryName(option) }}
        </Flex>
      </Flex>
    </Flex>
  </div>
</template>

<script>
import Flex from '@wizer/core/components/flex/Flex'
import Icon from '@wizer/core/components/icon/Icon'

export default {
  name: 'DropDown',
  components: {
    Flex,
    Icon,
  },
  props: {
    options: {
      type: [Array, Object],
    },
    selectedOptionIndex: Number,
  },
  data() {
    return {
      showMenu: false,
      selectedOption: this.options[0],
    }
  },
  watch: {
    selectedOptionIndex(index) {
      // If non default option is selected, option will be passed after the element is rendered,
      // therefore a watch is needed
      if (index) {
        this.updateOption(this.options[index])
      }
    },
  },
  methods: {
    getCategoryName(category) {
      if (!category.staticValue) {
        return this.$t(category.name)
      }
      return `${this.$t(category.name)} ${category.attributeValue}`
    },
    updateOption(option) {
      this.selectedOption = option
      this.showMenu = false
      this.$emit('updateOption', this.selectedOption)
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    clickHandler(event) {
      const { target } = event
      const { $el } = this

      if (!$el.contains(target)) {
        this.showMenu = false
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.clickHandler)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickHandler)
  },
}
</script>

<style lang="postcss" scoped>
.menu {
  @apply flex-col absolute bg-white border border-solid left-0 z-10 inline-flex;
  top: 100%;
  min-width: 100%;
}
.selector {
  @apply border border-solid rounded ml-1 px-1 cursor-pointer relative;
}
.menu-item {
  @apply p-1 inline-flex;
}
.menu-item:hover {
  @apply bg-blue-400;
}
.dropdown-selected {
  @apply whitespace-no-wrap;
}
</style>
